<template lang="pug">
#locations
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    nav
      select-btns(
        :programList="programProductGroupList",
        :selectIndex.sync="selectIndex"
      )
      course-filter(
        ref="courseFilter",
        :cityValue.sync="queryCityId",
        :districtValue.sync="queryDistrictId"
      )
    .row.clear
      .col
        course-location(
          v-for="(court, index) in programCourtList",
          :court="court",
          :campName="programProductGroupName",
          :coachList="coaches",
          :key="index"
        )
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import CustomFilter from "@/components/locations/Filter";
import CourseLocation from "@/components/locations/CourseLocation";
import CourseFilter from "@/components/locations/CourseFilter";
import Breadcrumb from "@/components/common/Breadcrumb";
import SelectBtns from "@/components/common/SelectBtns";
import {
  getProgramProductGroupList,
  getProgramProductGroupByID,
} from "@/api/ecommerce";
import { getCoachList } from "@/api/web_content";

export default {
  name: "Locations",
  components: {
    "custom-footer": CustomFooter,
    "custom-filter": CustomFilter,
    "course-location": CourseLocation,
    "course-filter": CourseFilter,
    "select-btns": SelectBtns,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "課程地點",

      programProductGroupList: [],
      selectIndex: 0,
      programProductGroup: {},
      programProductGroupName: "",
      programCourtList: [],

      coaches: [],

      queryCourseTypeId: this.$route.params.programProductGroupSelect || -1,
      queryCityId: -1,
      queryDistrictId: -1,

      testCity: this.$route.params.cityId,
      testDistrict: this.$route.params.districtId,
    };
  },
  created() {
    this.getProgramProductGroupList();
    this.getCoachList();
  },
  watch: {
    selectIndex() {
      this.queryCityId = -1;
      this.queryDistrictId = -1;
      this.programProductGroupName =
        this.programProductGroupList[this.selectIndex].name;
      this.getProgramProductGroupByID(
        this.programProductGroupList[this.selectIndex].id
      );
    },
    queryCityId() {
      this.filterCourts();
    },
    queryDistrictId() {
      this.filterCourts();
    },
    "$route.query.id"() {
      this.programProductGroup = {};
      this.$refs["courseFilter"].setCityList([]);
      this.programProductGroupList = [];
      this.selectIndex = 0;
      this.programCourtList = [];
      this.getProgramProductGroupList();
    },
  },
  methods: {
    filterCourts() {
      let tempProgramCourtList = this.programProductGroup.courts;
      if (this.queryCityId == -1) {
        this.programCourtList = tempProgramCourtList;
      } else {
        if (this.queryDistrictId == -1) {
          this.programCourtList = tempProgramCourtList.filter(
            (court) => court.city.id == this.queryCityId
          );
        } else {
          this.programCourtList = tempProgramCourtList.filter(
            (court) => court.district.id == this.queryDistrictId
          );
        }
      }
    },
    getProgramProductGroupList() {
      this.programProductGroupList = [];
      let params = {
        program: this.$route.query.id,
      };
      getProgramProductGroupList(params).then((response) => {
        let tempList = response.data;
        for (let index in tempList) {
          let temp = tempList[index];
          if (!temp.is_additional) {
            this.programProductGroupList.push(temp);
          }
        }

        if (
          this.programProductGroupList &&
          this.programProductGroupList.length > 0
        ) {
          this.programProductGroupName =
            this.programProductGroupList[this.selectIndex].name;
          this.getProgramProductGroupByID(
            this.programProductGroupList[this.selectIndex].id
          );
        }
      });
    },
    getProgramProductGroupByID(id) {
      getProgramProductGroupByID(id).then((response) => {
        this.programProductGroup = response.data;
        this.programCourtList = this.programProductGroup.courts;
        this.$refs["courseFilter"].setCityList(this.programProductGroup.cities);
        this.queryCityId = this.testCity || -1;
        this.queryDistrictId = this.testDistrict || -1;
      });
    },
    getCoachList() {
      getCoachList().then((response) => {
        this.coaches = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#locations {
  background-color: $color_bg_white;
}

@media (max-width: 767px) {
  .locations {
    clear: both;
    float: left;
  }
}
</style>
